import * as types from './types'

export default {
  [types.SET_STEP](state, data) {
    state.step = data
  },
  [types.RESET_VISITED_STEP](state, data) {
    state.visitedStep = data
  },
  [types.SET_VISITED_STEP](state, currentStep) {
    state.visitedStep = currentStep > state.visitedStep
      ? currentStep
      : state.visitedStep
  },
  [types.RESET_SUBMODELS](state) {
    state.isSubmodelSelected = false
  },
  [types.SET_SCANPRO_CONFIGURATION](state, data) {
    state.scanproConfiguration = data
    state.scanProChecklist = []
    state.scanProCriteria = []
    // set the shop's criteria and checklist items
    if (data !== undefined && data !== null) {
      for (let item of data) {
        if (item.criteriaDetail !== null) {
          state.scanProCriteria.push({
            id: item.scanProId,
            value: item.criteriaDetail,
            selected: true,
            changed: false
          })
        } else {
          state.scanProChecklist.push({
            id: item.scanProId,
            value: item.scanProCriteria,
            selected: true,
            changed: false
          })
        }
      }
    }
  },
  [types.SET_DECODED_VIN](state, { data, vin }) {
    state.safety = null
    state.decodedVin = null
    state.isDecoded = false
    state.submodels = []
    state.isSubmodelSelected = false
    state.vehicle = null
    state.vin = vin
    try {
      state.submodels.push({
        value: 0,
        name: ''
      })
      if (data.decoder_messages.decoder_errors.length === 0) {
        state.decodedVin = data
        state.isDecoded = true
        let styles = data.query_responses.Request_Result.us_market_data.us_styles
        for (let style of styles) {
          state.submodels.push({
            value: style.vehicle_id,
            name: style.name
          })
        }
      }
    } catch (e) { }
  },
  [types.SET_VEHICLE](state, id) {
    state.vehicle = null
    state.safety = null
    for (let style of state.decodedVin.query_responses.Request_Result.us_market_data.us_styles) {
      if (style.vehicle_id === id) {
        state.vehicle = style
        state.isSubmodelSelected = true
        break
      }
    }
    if (state.vehicle !== null) {
      // for (let equip of state.vehicle.standard_generic_equipment) {
      //   if (equip.generic_equipment_category_group === 'Safety and Security') {
      //     for (let category of equip.generic_equipment_categories) {
      //       if (category.generic_equipment_category === 'Safety') {
      //         state.safety = category.generic_equipment
      //         console.log('Safety Info', JSON.stringify(state.safety))
      //         break
      //       }
      //     }
      //     break
      //   }
      // }
    }
  },
  [types.SET_RECOMMENDATION](state, data) {
    state.recommendation = data
    state.safety = []
    let idx = 0
    if (data !== undefined && data !== null) {
      if (data.scanRecommendation !== undefined && data.scanRecommendation !== null) {
        if (data.scanRecommendation.safetyFeatures !== undefined && data.scanRecommendation.safetyFeatures !== null) {
          for (let item of data.scanRecommendation.safetyFeatures) {
            idx++
            state.safety.push({
              id: idx,
              name: item
            })
          }
        }
      }
    }
    console.log('Eval Recommendation', { recommendation: state.recommendation, safety: state.safety })
  },
  [types.SET_SELECTED_CHECKLIST_ITEMS](state, data) {
    state.selectedChecklistItems = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/scanpro/mutations.js